var render, staticRenderFns
import script from "./contract_detail.vue?vue&type=script&lang=js"
export * from "./contract_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29461860')) {
      api.createRecord('29461860', component.options)
    } else {
      api.reload('29461860', component.options)
    }
    
  }
}
component.options.__file = "found/views/dms/views/contract/components/contract_detail.vue"
export default component.exports